// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__120G_","content":"styles_content__2HJsa"};